import React from 'react';
import { Outlet } from 'react-router-dom';

const EditNonAcademicVacancy: React.FC = () => <Outlet />;

export default EditNonAcademicVacancy;
